/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import styled from 'styled-components';
import { Card } from 'react-bootstrap';

export const ModalStyle: any = {
  overlay: {
    zIndex: 1090,
    backgroundColor: 'transparent',
  },
  content: {
    backgroundColor: 'rgba(0,0,0,0.5)',
    // overflow: 'hidden', // Needed, otherwise keyboard shortcuts scroll the page
    border: 'none',
    borderRadius: 0,
    padding: 0,
    //   alignItems: "center",
    justifyContent: 'center',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
  },
};

export const ToolbarContainer: any = {
  backgroundColor: 'rgba(0,0,0,0.5)',
  position: 'absolute',
  left: 0,
  right: 0,
  display: 'flex',
  justifyContent: 'space-between',
};

export const DocumentContainer: any = {
  marginTop: '110px',
};

export const Container: any = styled(Card)`
  .ReactModal__Overlay.ReactModal__Overlay--after-open {
    z-index: 1090 !important;
  }

  .qr-modal {
    z-index: 1090 !important;
  }

  .ReactModal__Content.ReactModal__Content--after-open.qr-modal {
    height: 100%;
  }
`;
